export const UPLOADS_QUERY_KEY = 'uploads';
export const UPLOAD_QUERY_KEY = 'upload';
